import { Layout } from 'features/auth/Layout';
import { Button } from 'features/components/Button';
import { ROUTE_MAP } from 'features/entry-form-v2/utils/routeMap';
import { useSelector } from 'hooks/utils';
import { Link, useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import { logout } from './utils';
import { MILLIS_BEFORE_LOGOUT } from 'features/auth/auto-logout/InactivityDetector';

export function LogoutPage() {
	const language = useSelector(state => state.ui.i18n.language);
	const dictionary = DICTIONARY[language];
	const [searchParams] = useSearchParams();

	useEffect(() => {
		logout();
	}, []);

	const getLogoutReason = (reason: string | null) => {
		if (reason === 'inactivity') {
			return dictionary.REASONS.INACTIVITY;
		}

		return null;
	};

	const logoutReason = getLogoutReason(searchParams.get('reason'));

	return (
		<Layout title={dictionary.title}>
			{logoutReason && (
				<div className="mx-auto max-w-2xl rounded-md bg-blue-50 p-4 mb-8">
					<div className="flex items-start">
						<div className="ml-3 text-left">
							<h3 className="text-sm font-medium text-blue-800">
								{logoutReason.title}
							</h3>
							<div className="mt-2 text-sm text-blue-800">
								<p>{logoutReason.description}</p>
							</div>
						</div>
					</div>
				</div>
			)}
			<Link to={ROUTE_MAP.auth.login.createPath()} replace className="self-center">
				<Button text={dictionary.toLogIn} />
			</Link>
		</Layout>
	);
}

const MINUTES_BEFORE_LOGOUT = MILLIS_BEFORE_LOGOUT / 60000;
const DICTIONARY = {
	EN: {
		title: 'You got signed out',
		toLogIn: 'Back to log in',
		REASONS: {
			INACTIVITY: {
				title: 'You were signed out due to inactivity',
				description: `To protect your account and data, we automatically sign you out after ${MINUTES_BEFORE_LOGOUT} minutes of inactivity.`
			}
		}
	},

	NB: {
		title: 'Du ble logget ut',
		toLogIn: 'Til innlogging',
		REASONS: {
			INACTIVITY: {
				title: 'Du ble logget ut på grunn av inaktivitet',
				description: `For å beskytte kontoen din og dataene dine, logges du automatisk ut etter ${MINUTES_BEFORE_LOGOUT} minutter med inaktivitet.`
			}
		}
	}
} as const;

export type LogoutReason = 'inactivity';
